var _rect, _rect2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFreq(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#96CEFD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 32,
    height: 32,
    rx: 16,
    stroke: "#B5DEFF",
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1543_28537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 11.3334L19.3333 13.3334M19.3333 13.3334L17.3333 15.3334M19.3333 13.3334H14.5333C13.4132 13.3334 12.8532 13.3334 12.4253 13.5514C12.049 13.7431 11.7431 14.0491 11.5513 14.4254C11.3333 14.8532 11.3333 15.4133 11.3333 16.5334V20.3334C11.3333 20.643 11.3333 20.7978 11.3504 20.9278C11.4686 21.8252 12.1748 22.5314 13.0723 22.6496C13.2022 22.6667 13.357 22.6667 13.6667 22.6667M16.6667 22.6667H21.4667C22.5868 22.6667 23.1468 22.6667 23.5746 22.4487C23.951 22.257 24.2569 21.951 24.4487 21.5747C24.6667 21.1469 24.6667 20.5868 24.6667 19.4667V15.6667C24.6667 15.3571 24.6667 15.2023 24.6496 15.0723C24.5314 14.1749 23.8252 13.4686 22.9277 13.3505C22.7977 13.3334 22.6429 13.3334 22.3333 13.3334M16.6667 22.6667L18.6667 24.6667M16.6667 22.6667L18.6667 20.6667",
    stroke: "#0265DC",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1543_28537"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreq);
export default __webpack_public_path__ + "static/media/freq.6cd7c4e29a40578695be20fe75500861.svg";
export { ForwardRef as ReactComponent };